package ru.villawonka.app.data.entity.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PaginatedResponse<T>(
    @SerialName("total_count") val totalCount: Int,
    @SerialName("current_page") val currentPage: Int,
    @SerialName("page_size") val pageSize: Int,
    @SerialName("has_next") val hasNext: Boolean,
    @SerialName("data") val data: List<T>,
)